(() => {
  'use strict';
  
  const scriptEl = document.currentScript;
  if (!scriptEl) return;

  const sectionId = scriptEl.dataset.sectionId;
  const SECTION = document.querySelector('#shopify-section-' + sectionId);

  /* Start - Add to Cart Modal */
  const _modalLoads = new Set();

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-product-modal]');
    if (!button) return;

    if (SECTION && !SECTION.contains(button)) return;

    const handle = button.dataset.productModal;
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();

    if (_modalLoads.has(handle)) return;
    _modalLoads.add(handle);

    const spinner = button.querySelector('.loading-overlay__spinner');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    spinner?.classList.remove('hidden');

    const url = `${window.shopUrl}/products/${handle}?view=modal`;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();

      document.querySelector('.nextdev--product-modal')?.remove();

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html.trim();

      const modalEl = tempDiv.querySelector('.nextdev--product-modal');
      if (modalEl) {
        await ensureLoopCSSFromHTML(tempDiv, url);

        SECTION.appendChild(modalEl);
        runLoopScriptsIn(modalEl);

        requestAnimationFrame(() => {
          modalEl.classList.remove('hide');
          initLoopSubscriptions(modalEl);
        });

        document.body.classList.add('overflow-hidden');
        initModal(modalEl);
      }
    } catch (err) {
      console.error('Modal load failed:', err);
    } finally {
      _modalLoads.delete(handle);
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  });

  function initModal(modal) {
    const closeBtn = modal.querySelector('.nextdev--product-modal--close');
    closeBtn?.addEventListener('click', closeModal);

    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    function closeModal() {
      modal.classList.add('hide');
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => modal.remove(), 200);
    }

    const swiperMedia = modal.querySelector('.swiper--media');
    if (swiperMedia) {
      const swiperInstance = new Swiper(swiperMedia, {
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: { forceToAxis: true },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      });
      window.swiperMediaModal = swiperInstance;
    }

    const sizeGuideBtn = modal.querySelector('[data-size-guide]');
    const sizeGuideModal = document.querySelector('#SizeGuideModal');
    if (sizeGuideBtn && sizeGuideModal) {
      sizeGuideBtn.addEventListener('click', (e) => {
        e.preventDefault();
        sizeGuideModal.classList.add('active');
      });
    }

    const sizeGuideImageBtn = modal.querySelector('[data-size-guide-image]');
    if (sizeGuideImageBtn) {
      const swiperMediaSizeGuideImage = modal.querySelector('.swiper--media .nextdev--product-modal--media--image img[alt="size-guide"]');
      const swiperMediaSizeGuideImageIndex = swiperMediaSizeGuideImage.closest('.swiper-slide');

      sizeGuideImageBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.swiperMediaModal.slideTo(swiperMediaSizeGuideImageIndex.dataset.index);
      });
    }
  }

  function runLoopScriptsIn(root) {
    const all = root.querySelectorAll('script');
    all.forEach((old) => {
      const src = old.getAttribute('src') || '';
      const isLoop =
        /loop/i.test(src) ||
        old.hasAttribute('data-loop') ||
        /Loop\s?Subscriptions|window\.Loop/i.test(old.textContent || '');

      if (!isLoop) return;

      const s = document.createElement('script');
      for (const { name, value } of old.attributes) s.setAttribute(name, value);
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  function initLoopSubscriptions(root = document) {
    const targets = root.querySelectorAll(
      '[data-loop-subscription], .loop-subscription-widget, [data-loop-widget]'
    );

    targets.forEach((el) => {
      if (el.dataset.loopMounted === '1') return;

      const api =
        window.LoopSubscriptions ||
        window.loopSubscriptions ||
        window.Loop ||
        null;

      if (api?.mount) {
        api.mount(el);
        el.dataset.loopMounted = '1';
        return;
      }
      if (api?.refresh) {
        api.refresh(el);
        el.dataset.loopMounted = '1';
        return;
      }

      if (!window.__loopEmbedKicked) {
        const script = document.querySelector('script[src*="loop"]');
        if (script) {
          const clone = document.createElement('script');
          for (const { name, value } of script.attributes) clone.setAttribute(name, value);
          script.parentNode.insertBefore(clone, script.nextSibling);
          window.__loopEmbedKicked = true;
        }
      }
    });
  }

  function ensureLoopCSSFromHTML(fragment, baseUrl) {
    const link = [...fragment.querySelectorAll('link[rel="stylesheet"], link[rel="preload"][as="style"]')]
      .find(l => /loop_widget\.css(?:\?|$)/i.test(l.getAttribute('href') || '')
            || /\/loop.*\.css/i.test(l.getAttribute('href') || ''));

    if (!link) return Promise.resolve();

    const href = new URL(link.getAttribute('href'), baseUrl).href;

    const already = [...document.querySelectorAll('link[rel="stylesheet"][href], link[rel="preload"][as="style"][href]')]
      .some(x => x.href === href) || document.querySelector(`link[data-loop-css][href="${href}"]`);

    if (already) return Promise.resolve();

    return new Promise((resolve) => {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      if (link.media) l.media = link.media;
      l.setAttribute('data-loop-css', '1');
      l.onload = () => resolve();
      l.onerror = () => resolve();
      document.head.appendChild(l);
    });
  }
  /* End - Add to Cart Modal */
})();

class OptionRadios extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onOptionChange);
    this.updateOptions();
    this.updateMasterId();
    this.onQuantityChange();

    /* Start - Loop Subscription */
    function debounce(fn, delay) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), delay);
      };
    }

    ((host) => {
      let current;

      const attach = (el) => {
        host._loopContainerObserver?.disconnect();

        const debounced = debounce(host.onLoopSubscriptionChange.bind(host), 200);
        const innerObs = new MutationObserver(debounced);
        innerObs.observe(el, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });

        host._loopContainerObserver = innerObs;
      };

      const rootObs = new MutationObserver(() => {
        const el = document.querySelector('.loop-widget-container');
        if (el && el !== current) {
          current = el;
          attach(el);
        }
      });

      rootObs.observe(document.documentElement, { childList: true, subtree: true });
      host._loopRootObserver = rootObs;

      const existing = document.querySelector('.loop-widget-container');
      if (existing) {
        current = existing;
        attach(existing);
      }
    })(this);
    /* End - Loop Subscription */
  }

  /* Start - Loop Subscription */
  disconnectedCallback() {
    this._loopRootObserver?.disconnect();
    this._loopContainerObserver?.disconnect();
  }
  
  onLoopSubscriptionChange() {
    const loopSubscriptionContainer = document.querySelector('.loop-widget-container');
    const loopSubscriptionSelectedOption = loopSubscriptionContainer?.querySelector('.loop-w-checkbox-purchase-option.loop-widget-purchase-option-selected');

    if (loopSubscriptionSelectedOption) {
      this.toggleAddButton(false, false, '', loopSubscriptionSelectedOption.textContent.trim());
    } else {
      this.toggleAddButton(false, false);
    }
  }
  /* End - Loop Subscription */

  onQuantityChange() {
    const quantityOptions = document.querySelector('.nextdev--product-modal--info__quantity--options');
    if (quantityOptions != null) {
      const quantityOptionsInput = quantityOptions.querySelectorAll('input');
      const selectedQuantityOption = quantityOptions.closest('.nextdev--product-modal--info__quantity').querySelector('.nextdev--product-modal--info__quantity--selected span');

      quantityOptionsInput.forEach((quantityOption) => {
        const quantityOptionContainer = quantityOption.closest('.nextdev--product-modal--info__quantity--option');
        const quantityOptionTitle = quantityOptionContainer.querySelector('.nextdev--product-modal--info__quantity--option__info--title').textContent.trim();
        const quantityOptionVariants = JSON.parse(quantityOptionContainer.querySelector('[type="application/json"]').textContent);

        quantityOption.addEventListener('change', () => {
          selectedQuantityOption.textContent = quantityOptionTitle;

          if (this.currentVariant) {
            const mainVariantOptions = this.currentVariant.options;
            const matchingVariant = quantityOptionVariants.find(variant => {
              return JSON.stringify(variant.options) === JSON.stringify(mainVariantOptions);
            });

            if (matchingVariant) {
              const variant_id = matchingVariant.id;
              this.updateVariantInput(variant_id);

              this.toggleAddButton(false, false, '', matchingVariant.price);
            } else {
              this.toggleAddButton(true, true);
            }
          }
        });
      });
    }
  }

  onOptionChange(e) {
    const target = e.target;
    const option = target.closest('.nextdev--product-modal--info__option');
    const optionSelected = option.querySelector('.nextdev--product-modal--info__option--selected span');
    optionSelected.textContent = target.value;
    
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, false, '', this.currentVariant.price);
      this.updateMedia();
      // this.updateURL();
      this.updateVariantInput();
      this.renderInfo();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaId = this.currentVariant.featured_media.id;

    const swiperMain = document.querySelector('.nextdev--product-modal .swiper--media');
    const swiperMainSlide = swiperMain.querySelector('[data-media-id="' + mediaId + '"]');
    
    if (!swiperMainSlide) return;

    window.swiperMediaModal.slideTo(swiperMainSlide.dataset.index);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    urlParams.delete('variant');

    let params = urlParams.toString();
    if (params != '') params = '&' + params;

    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}${params}`
    );
  }

  renderInfo() {
    fetch(
      `${this.dataset.url}?view=modal&variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const html_price = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const prices = document.querySelectorAll(`#price-${this.dataset.section}`);
      if (prices.length > 0 && html_price != null) {
        prices.forEach((price) => {
          price.innerHTML = html_price.innerHTML;
          price.classList.remove('visibility-hidden');
        });
      }

      const html_freeShipping = html.getElementById(`freeShipping-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const freeShipping = document.querySelector(`#freeShipping-${this.dataset.section}`);
      if (html_freeShipping && freeShipping != null) {
        freeShipping.innerHTML = html_freeShipping.innerHTML;
      }

      const html_quantityOptions = html.getElementById(`quantityOptions-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const quantityOptions = document.querySelector(`#quantityOptions-${this.dataset.section}`);
      if (html_quantityOptions && quantityOptions != null) {
        const selectedQuantityOption = quantityOptions.closest('.nextdev--product-modal--info__quantity').querySelector('.nextdev--product-modal--info__quantity--selected span');

        quantityOptions.innerHTML = html_quantityOptions.innerHTML;
        this.onQuantityChange();

        const quantityOptionsTitle = quantityOptions.querySelectorAll('.nextdev--product-modal--info__quantity--option__info--title');
        quantityOptionsTitle.forEach((quantityOptionTitle) => {
          if (quantityOptionTitle.textContent.trim() == selectedQuantityOption.textContent.trim()) {
            const quantityOptionInput = quantityOptionTitle.closest('.nextdev--product-modal--info__quantity--option').querySelector('input');

            quantityOptionInput.checked = true;
            quantityOptionInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }).catch(console.error);
  }

  updateOptions() {
    const optionElements = Array.from(this.querySelectorAll('.nextdev--product-modal--info__option'));
    this.options = optionElements.map((optionElement) => {
      return Array.from(optionElement.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateVariantInput(variant_id = 0) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = (variant_id > 0) ? variant_id : this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  toggleAddButton(disable = false, soldOut = false, text = '', price = 0) {
    const productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = (text != '') ? text : addButton.dataset.text;
    const soldOutButtonText = addButton.dataset.soldout;
    const addButtonPrice = addButton.dataset.price;

    const addButtonContent = addButton.querySelector('span');

    if (soldOut == true || !this.currentVariant.available) {
      addButtonContent.textContent = soldOutButtonText;
      addButton.disabled = true;
      return;
    }

    addButton.disabled = disable;

    if (addButtonPrice == 'true') {
      /* Start - Loop Subscription */
      const loopSubscriptionContainer = document.querySelector('.loop-widget-container');

      if (loopSubscriptionContainer != null) {
        setTimeout(() => {
          const loopSubscriptionSelectedOption = loopSubscriptionContainer.querySelector('.loop-w-checkbox-purchase-option.loop-widget-purchase-option-selected');
        
          if (loopSubscriptionSelectedOption) {
            const loopSubscriptionSelectedOptionPrice = loopSubscriptionSelectedOption.querySelector('.loop-w-checkbox-purchase-option-price').textContent.trim();

            addButtonContent.textContent = `${addButtonText} - ${loopSubscriptionSelectedOptionPrice}`;
          } else {
            addButtonContent.textContent = addButtonText + ' - ' + Shopify.formatMoney(
              (price > 0 ? price : this.currentVariant.price),
              'amount_no_decimals'
            );
          }
        }, 250);

        return;
      }
      /* End - Loop Subscription */

      if (typeof price == 'string') {
        addButtonContent.textContent = `${addButtonText} - ${price}`;

        return;
      }

      addButtonContent.textContent = addButtonText + ' - ' + Shopify.formatMoney(
        (price > 0 ? price : this.currentVariant.price),
        'amount_no_decimals'
      );

      return;
    }

    addButtonContent.textContent = addButtonText;
  }

  setUnavailable() {
    const prices = document.querySelectorAll(`#price-${this.dataset.section}`);
    if (prices.length > 0) {
      prices.forEach((price) => {
        price.classList.add('visibility-hidden');
      });
    }
  }

  removeErrorMessage() {
    const productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    if (productForm) productForm.closest('product-form').handleErrorMessage();
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('option-radios', OptionRadios);